export default __webpack_public_path__ + "static/media/Selfielocation_artillery.5d03b564.png";